import axiosInstance from "../config/axios";

export interface Session {
  username: string;
  limited: boolean;
  limitedAt: string | null;
  pending: number;
  apis: Record<
    string,
    {
      remaining: number;
      reset: string;
    }
  >;
}

export interface CreateSessionPayload {
  username: string;
  password: string;
  otpSecret: string;
}

class SessionService {
  async getSessions(): Promise<Session[]> {
    const response = await axiosInstance.get("/crawler/session/debug");
    return response.data;
  }

  async createSession(payload: CreateSessionPayload): Promise<void> {
    await axiosInstance.post("/crawler/session", payload);
  }

  async deleteSession(id: string): Promise<void> {
    await axiosInstance.delete(`/crawler/session/${id}`);
  }
}

export const sessionService = new SessionService();
